import { UIElement } from './uiElement';
import { IUIElementOptions } from '../../../interfaces/options';
import { Templates } from '../../../compile';
import QRCodeLib from 'qrcode';

export class QRCode extends UIElement<string> {
    public dataUrl: KnockoutObservable<string>;

    constructor(id: string, label: string, value: string | KnockoutObservable<string>, options?: IUIElementOptions) {
        options = $.extend(
            true,
            {},
            <IUIElementOptions>{
                template: Templates.layouts_uiElements_noValidation,
                widget: {
                    widget: Templates.widgets_qrcode
                }
            },
            options || {}
        );
        super(id, label, value, options);

        this.dataUrl = ko.observable<string>();

        this.value.subscribe(newValue => {
            QRCodeLib.toDataURL(newValue, (err, url) => {
                this.dataUrl(url);
            });
        });
    }
}
